import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SectionHeader, Reveal, Pill } from "@/components/Bits";
import { PROJECTS } from "@/data/portfolio";

export default function Projects() {
  return (
    <div data-testid="projects-page" className="max-w-6xl mx-auto px-6 md:px-10 pt-16 md:pt-24">
      <SectionHeader
        eyebrow="Selected work"
        title="Case studies &amp;"
        emphasis="deep-dives."
        sub="A peek at the product problems I've sunk my teeth into — from gardening MVPs to fintech utilities and gamified growth. Tap any card for the full case study."
      />

      <div className="grid md:grid-cols-2 gap-7">
        {PROJECTS.map((p, i) => (
          <Reveal key={p.slug} delay={i * 0.08}>
            <Link
              to={`/projects/${p.slug}`}
              data-testid={`project-card-${p.slug}`}
              className="soft-card group block overflow-hidden h-full"
            >
              <div className="relative h-56 md:h-64 overflow-hidden" style={{ background: `var(--${p.accent}-soft)` }}>
                <div className="absolute inset-0 flex items-center justify-center text-8xl md:text-9xl opacity-90 select-none">
                  {p.emoji}
                </div>
                <div className="absolute top-5 left-5">
                  <Pill variant={p.accent}>Case study</Pill>
                </div>
                <div className="absolute top-5 right-5 w-11 h-11 rounded-full bg-[var(--surface)] flex items-center justify-center shadow-sm">
                  <ArrowUpRight className="w-5 h-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                </div>
              </div>
              <div className="p-7">
                <h3 className="font-display text-2xl md:text-3xl font-medium leading-tight">{p.title}</h3>
                <p className="mt-4 text-[var(--text-muted)] leading-relaxed">{p.blurb}</p>
                <div className="mt-5 flex flex-wrap gap-1.5">
                  {p.tags.map((t) => (
                    <Pill key={t}>{t}</Pill>
                  ))}
                </div>
                <div className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold">
                  Read the full case study
                  <ArrowUpRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.3}>
        <div className="mt-20 rounded-3xl overflow-hidden relative bg-[var(--sage-soft)] p-10 md:p-16">
          <div className="blob bg-[var(--sage)] w-60 h-60 -top-20 -left-10" />
          <div className="relative">
            <Pill>More in the works</Pill>
            <h3 className="mt-5 font-display text-3xl md:text-5xl font-light max-w-2xl leading-tight">
              Want a deeper walkthrough of any of these?
            </h3>
            <p className="mt-4 text-lg text-[var(--text-muted)] max-w-xl">
              I love nerding out on the &quot;why&quot; behind product decisions.
            </p>
            <Link to="/contact" className="mt-8 btn-primary" data-testid="projects-cta-contact">
              Get in touch
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </Reveal>
    </div>
  );
}
